import { useState, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import "@/App.css";
import { Menu, X, Phone, MapPin, Facebook, Instagram, ArrowRight, ChevronDown, Music, Utensils, Camera, Sparkles, Users, Star, ChevronLeft, ChevronRight as ChevronRightIcon, ArrowLeft } from "lucide-react";
import { Toaster } from "sonner";

// ===========================================
// KONFIGURACIJA - Prilagodi za svoj hosting
// ===========================================

// Ako koristiš PHP backend na hostingu, postavi ovo na true
const USE_PHP_BACKEND = true;

// URL do api.php fajla na tvom hostingu (npr. "https://tvoj-sajt.com/api.php")
const PHP_API_URL = "/api.php";

// Fallback slike ako PHP ne radi ili za development
const FALLBACK_GALLERY_IMAGES = [
  "https://customer-assets.emergentagent.com/job_proslave-kabinet/artifacts/l2w2nbtw_FB_IMG_1769511299851.jpg",
  "https://customer-assets.emergentagent.com/job_proslave-kabinet/artifacts/9kdnhik2_FB_IMG_1769511616001.jpg",
  "https://customer-assets.emergentagent.com/job_proslave-kabinet/artifacts/rq5jdn3w_FB_IMG_1769511660102.jpg",
  "https://customer-assets.emergentagent.com/job_proslave-kabinet/artifacts/4kfnxe9p_FB_IMG_1769511303240.jpg",
  "https://customer-assets.emergentagent.com/job_proslave-kabinet/artifacts/8ine6w0p_FB_IMG_1769511610819.jpg",
  "https://customer-assets.emergentagent.com/job_de26a693-6312-4006-859a-46abd035f31f/artifacts/za5vwto7_img_43_1769509411284.jpg",
  "https://customer-assets.emergentagent.com/job_de26a693-6312-4006-859a-46abd035f31f/artifacts/rtqn7nyj_img_35_1769509344705.jpg",
  "https://customer-assets.emergentagent.com/job_de26a693-6312-4006-859a-46abd035f31f/artifacts/z6dgzwin_img_36_1769509354353.jpg",
  "https://customer-assets.emergentagent.com/job_de26a693-6312-4006-859a-46abd035f31f/artifacts/2bida19f_img_12_1769509057880.jpg",
  "https://customer-assets.emergentagent.com/job_de26a693-6312-4006-859a-46abd035f31f/artifacts/n5ro359m_img_40_1769509382280.jpg",
];

const FALLBACK_VENUE_IMAGES = [
  "https://customer-assets.emergentagent.com/job_proslave-kabinet/artifacts/u26255p3_IVAN1634.jpg",
  "https://customer-assets.emergentagent.com/job_proslave-kabinet/artifacts/ucfjc9h8_DSC_1583.jpg",
  "https://customer-assets.emergentagent.com/job_proslave-kabinet/artifacts/cxe1d1pg_DSC_1553.jpg",
  "https://customer-assets.emergentagent.com/job_proslave-kabinet/artifacts/r2m1cj1p_DSC_1563.jpg",
  "https://customer-assets.emergentagent.com/job_proslave-kabinet/artifacts/1t4lxbg6_IVI_8512.jpg",
];

const FALLBACK_HERO_IMAGES = [
  "https://customer-assets.emergentagent.com/job_proslave-kabinet/artifacts/u26255p3_IVAN1634.jpg",
  "https://customer-assets.emergentagent.com/job_proslave-kabinet/artifacts/ucfjc9h8_DSC_1583.jpg",
  "https://customer-assets.emergentagent.com/job_proslave-kabinet/artifacts/cxe1d1pg_DSC_1553.jpg",
  "https://customer-assets.emergentagent.com/job_proslave-kabinet/artifacts/r2m1cj1p_DSC_1563.jpg",
  "https://customer-assets.emergentagent.com/job_proslave-kabinet/artifacts/1t4lxbg6_IVI_8512.jpg",
];

// ===========================================

// Celebration types
const CELEBRATIONS = [
  {
    id: 1,
    title: "18. Rođendani",
    subtitle: "Punoletstvo",
    description: "Napravite svoj 18. rođendan nezaboravnim!",
    image: "https://customer-assets.emergentagent.com/job_de26a693-6312-4006-859a-46abd035f31f/artifacts/fcsowhy1_18.jpg",
  },
  {
    id: 2,
    title: "Diplomski",
    subtitle: "Proslavite uspeh",
    description: "Elegantne diplomske zabave.",
    image: "https://customer-assets.emergentagent.com/job_de26a693-6312-4006-859a-46abd035f31f/artifacts/a8qzp9om_dip.png",
  },
  {
    id: 3,
    title: "Rođendani",
    subtitle: "Za sve uzraste",
    description: "Svaki rođendan zaslužuje savršenu proslavu.",
    image: "https://images.unsplash.com/photo-1729127421701-cd573be47471?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwzfHxiaXJ0aGRheSUyMGNha2UlMjBjYW5kbGVzJTIwY2VsZWJyYXRpb24lMjBkYXJrJTIwbW9vZHl8ZW58MHx8fHwxNzcwOTk3NDI1fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: 4,
    title: "Rođenja deteta",
    subtitle: "Proslava rođenja",
    description: "Proslavite dolazak novog člana porodice!",
    image: "https://customer-assets.emergentagent.com/job_de26a693-6312-4006-859a-46abd035f31f/artifacts/qg5skgmo_viber_image_2026-02-16_20-20-30-015.jpg",
  },
  {
    id: 5,
    title: "Korporativne",
    subtitle: "Poslovni događaji",
    description: "Team building, godišnjice firme.",
    image: "https://images.pexels.com/photos/6405778/pexels-photo-6405778.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: 6,
    title: "Porodična okupljanja",
    subtitle: "Sve vrste proslava",
    description: "Okupite porodicu za nezaboravne trenutke.",
    image: "https://images.pexels.com/photos/3171201/pexels-photo-3171201.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

// Features
const FEATURES = [
  { icon: Music, title: "DJ ili Bend", description: "Prilagođena muzika onome što vi želite" },
  { icon: Utensils, title: "Ketering usluge", description: "Mogućnost organizacije hrane i pića" },
  { icon: Camera, title: "Fotograf", description: "Profesionalni fotograf za uspomene" },
  { icon: Sparkles, title: "Dekoracije", description: "Najbolje dekoracije za svaku priliku" },
  { icon: Star, title: "Torte", description: "Svečane torte za svaku priliku" },
  { icon: Users, title: "Privatno obezbeđenje", description: "Sigurnost i mir za vašu proslavu" },
];

// Hook za učitavanje slika
const useImages = () => {
  const [galleryImages, setGalleryImages] = useState(FALLBACK_GALLERY_IMAGES);
  const [venueImages, setVenueImages] = useState(FALLBACK_VENUE_IMAGES);
  const [heroImages, setHeroImages] = useState(FALLBACK_HERO_IMAGES);

  useEffect(() => {
    if (USE_PHP_BACKEND) {
      fetch(`${PHP_API_URL}?type=all`)
        .then(res => res.json())
        .then(data => {
          if (data.galerija && data.galerija.length > 0) setGalleryImages(data.galerija);
          if (data.prostor && data.prostor.length > 0) setVenueImages(data.prostor);
          if (data.hero && data.hero.length > 0) setHeroImages(data.hero);
        })
        .catch(err => console.log("Koristim fallback slike"));
    }
  }, []);

  return { galleryImages, venueImages, heroImages };
};

// Simple Image Slider Component
const ImageSlider = ({ images, title }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % images.length);
  const prevSlide = () => setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);

  useEffect(() => {
    const timer = setInterval(nextSlide, 4000);
    return () => clearInterval(timer);
  }, [images.length]);

  if (!images || images.length === 0) return null;

  return (
    <div className="relative max-w-4xl mx-auto">
      <div className="relative aspect-[16/10] overflow-hidden rounded-lg border border-[#D4AF37]/30">
        {images.map((img, idx) => (
          <img 
            key={idx}
            src={img}
            alt={`${title} ${idx + 1}`}
            className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${idx === currentIndex ? "opacity-100" : "opacity-0"}`}
          />
        ))}
      </div>
      <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 rounded-full bg-black/50 border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37]/20 transition-colors">
        <ChevronLeft className="w-6 h-6" />
      </button>
      <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 rounded-full bg-black/50 border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37]/20 transition-colors">
        <ChevronRightIcon className="w-6 h-6" />
      </button>
      <div className="flex justify-center gap-2 mt-6">
        {images.map((_, idx) => (
          <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2 h-2 rounded-full transition-all ${idx === currentIndex ? "bg-[#D4AF37] w-6" : "bg-white/30"}`} />
        ))}
      </div>
    </div>
  );
};

// Navigation Component
const Navigation = ({ activeSection, isGalleryPage = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY < 100) {
        setVisible(true);
      } else if (currentScrollY > lastScrollY) {
        setVisible(false);
      } else {
        setVisible(true);
      }
      setLastScrollY(currentScrollY);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY]);

  const scrollToSection = (id) => {
    if (isGalleryPage) {
      window.location.href = `/#${id}`;
      return;
    }
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsOpen(false);
    }
  };

  const navItems = [
    { name: "Početna", id: "hero" },
    { name: "Proslave", id: "proslave" },
    { name: "O nama", id: "o-nama" },
    { name: "Naš prostor", id: "nas-prostor" },
    { name: "Kontakt", id: "kontakt" },
  ];

  return (
    <>
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${visible ? "translate-y-0" : "-translate-y-full"} ${lastScrollY > 50 ? "glass-nav py-3" : "bg-transparent py-5"}`} data-testid="main-navigation">
        <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center" data-testid="logo-link">
              <img src="https://customer-assets.emergentagent.com/job_de26a693-6312-4006-859a-46abd035f31f/artifacts/e8m4prmg_logo%20kabinet.png" alt="Kabinet Proslave Logo" className="h-32 md:h-40 w-auto" />
            </Link>
            <div className="hidden lg:flex items-center gap-10">
              {navItems.map((item) => (
                <button key={item.id} onClick={() => scrollToSection(item.id)} className={`nav-link-luxury ${activeSection === item.id ? "active" : ""}`} data-testid={`nav-${item.id}`}>
                  {item.name}
                </button>
              ))}
              <Link to="/galerija" className="nav-link-luxury" data-testid="nav-galerija">
                Galerija
              </Link>
            </div>
            <button className="lg:hidden p-2 text-[#FAF8F5]" onClick={() => setIsOpen(!isOpen)} data-testid="mobile-menu-button">
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </nav>

      {isOpen && (
        <div className="fixed inset-0 bg-[#050505]/98 backdrop-blur-xl z-50 flex flex-col justify-center items-center" data-testid="mobile-menu">
          <button className="absolute top-6 right-6 p-2 text-[#FAF8F5]" onClick={() => setIsOpen(false)}>
            <X className="w-8 h-8" />
          </button>
          {navItems.map((item, idx) => (
            <button key={item.id} onClick={() => scrollToSection(item.id)} className="font-['Cormorant_Garamond'] text-3xl text-[#FAF8F5] hover:text-[#D4AF37] transition-colors py-4" style={{ animationDelay: `${idx * 0.1}s` }}>
              {item.name}
            </button>
          ))}
          <Link to="/galerija" className="font-['Cormorant_Garamond'] text-3xl text-[#FAF8F5] hover:text-[#D4AF37] transition-colors py-4" onClick={() => setIsOpen(false)}>
            Galerija
          </Link>
          <a href="tel:069713814" className="btn-luxury-primary mt-8">
            <Phone className="w-4 h-4 mr-2" />
            Pozovite nas
          </a>
        </div>
      )}
    </>
  );
};

// Hero Section - Full screen on desktop, nice image on mobile
const HeroSection = ({ heroImages }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroImages.length]);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % heroImages.length);
  const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + heroImages.length) % heroImages.length);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-testid="hero-section">
      {/* Background slider - visible on desktop */}
      <div className="hidden md:block absolute inset-0">
        {heroImages.map((slide, idx) => (
          <div key={idx} className={`absolute inset-0 transition-opacity duration-1000 ${idx === currentSlide ? "opacity-100" : "opacity-0"}`}>
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80 z-10" />
            <img src={slide} alt={`Slide ${idx + 1}`} className="w-full h-full object-cover" />
          </div>
        ))}
      </div>

      {/* Mobile layout with visible image */}
      <div className="md:hidden absolute inset-0 bg-[#050505]" />

      <div className="relative z-20 w-full max-w-7xl mx-auto px-0 md:px-8 lg:px-12 pt-20 md:pt-0">
        {/* Mobile: Image slider on top - full width */}
        <div className="md:hidden mb-4">
          <div className="relative w-full aspect-[16/10] overflow-hidden">
            {heroImages.map((slide, idx) => (
              <img 
                key={idx} 
                src={slide} 
                alt={`Slide ${idx + 1}`} 
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ${idx === currentSlide ? "opacity-100" : "opacity-0"}`}
              />
            ))}
            {/* Mobile arrows */}
            <button onClick={prevSlide} className="absolute left-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-black/50 border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37]">
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button onClick={nextSlide} className="absolute right-2 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-black/50 border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37]">
              <ChevronRightIcon className="w-5 h-5" />
            </button>
          </div>
          {/* Mobile dots */}
          <div className="flex justify-center gap-2 mt-4">
            {heroImages.map((_, idx) => (
              <button key={idx} onClick={() => setCurrentSlide(idx)} className={`h-2 rounded-full transition-all duration-300 ${idx === currentSlide ? "bg-[#D4AF37] w-6" : "bg-white/30 w-2"}`} />
            ))}
          </div>
        </div>

        {/* Text content */}
        <div className="text-center md:pt-0 px-4 md:px-0">
          <p className="text-xs md:text-sm tracking-[0.3em] uppercase text-[#D4AF37] mb-4 md:mb-6">Novi Sad</p>
          <h1 className="font-['Cormorant_Garamond'] text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-medium tracking-tight text-[#FAF8F5] mb-4 md:mb-6 leading-[1.1]">
            Proslave <span className="text-gold-gradient">Kabinet</span>
          </h1>
          <p className="text-base md:text-xl text-[#A1A1AA] md:text-[#E5E5E5] mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed">
            Ekskluzivan prostor za vaše najlepše trenutke
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button onClick={() => scrollToSection("kontakt")} className="btn-luxury-primary">
              Rezervišite termin
              <ArrowRight className="w-4 h-4 ml-2" />
            </button>
            <button onClick={() => scrollToSection("proslave")} className="btn-luxury-outline">
              Pogledajte ponudu
            </button>
          </div>
        </div>
      </div>

      {/* Desktop dots */}
      <div className="hidden md:flex absolute bottom-28 left-1/2 -translate-x-1/2 z-20 gap-2">
        {heroImages.map((_, idx) => (
          <button key={idx} onClick={() => setCurrentSlide(idx)} className={`h-2 rounded-full transition-all duration-300 ${idx === currentSlide ? "bg-[#D4AF37] w-8" : "bg-white/30 w-2 hover:bg-white/50"}`} />
        ))}
      </div>

      {/* Scroll indicator - desktop only */}
      <div className="hidden md:flex absolute bottom-8 left-1/2 -translate-x-1/2 flex-col items-center gap-2 animate-float z-20">
        <span className="text-xs tracking-[0.2em] uppercase text-[#A1A1AA]">Skrolujte</span>
        <ChevronDown className="w-5 h-5 text-[#D4AF37]" />
      </div>
    </section>
  );
};

// Celebrations Section
const CelebrationsSection = () => (
  <section id="proslave" className="py-12 md:py-20 bg-gradient-to-b from-[#050505] via-[#0A0808] to-[#050505]" data-testid="celebrations-section">
    <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
      <div className="text-center mb-10">
        <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-3">Naše usluge</p>
        <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-medium tracking-tight text-[#FAF8F5]">
          Organizujemo <span className="text-gold-gradient">sve vrste proslava!</span>
        </h2>
        <p className="text-[#A1A1AA] mt-4 max-w-2xl mx-auto">
          18. rođendani, diplomski, rođendani, rođenje deteta, korporativne proslave i porodična okupljanja
        </p>
        <div className="luxury-divider mx-auto mt-6" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {CELEBRATIONS.map((item) => (
          <div key={item.id} className="group relative overflow-hidden aspect-[3/4] cursor-pointer" data-testid={`celebration-${item.id}`}>
            <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#8B2942]/90 via-black/40 to-transparent group-hover:from-[#8B2942] transition-all duration-500" />
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <p className="text-xs tracking-[0.2em] uppercase text-[#D4AF37] mb-1">{item.subtitle}</p>
              <h3 className="font-['Cormorant_Garamond'] text-lg text-[#FAF8F5]">{item.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

// Gallery Preview Section
const GalleryPreviewSection = ({ galleryImages }) => (
  <section id="galerija-preview" className="py-8 md:py-16 bg-gradient-to-br from-[#0A0A0A] via-[#12080A] to-[#0A0A0A]" data-testid="gallery-preview-section">
    <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
      <div className="text-center mb-8">
        <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-3">Pogledajte</p>
        <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-medium tracking-tight text-[#FAF8F5]">
          Galerija <span className="text-gold-gradient">proslava</span>
        </h2>
        <div className="luxury-divider mx-auto mt-6" />
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        {galleryImages.slice(0, 8).map((img, idx) => (
          <div key={idx} className="aspect-square overflow-hidden group cursor-pointer">
            <img src={img} alt={`Proslava ${idx + 1}`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
          </div>
        ))}
      </div>
      <div className="text-center">
        <Link to="/galerija" className="btn-luxury-primary inline-flex">
          Pogledajte sve fotografije
          <ArrowRight className="w-4 h-4 ml-2" />
        </Link>
      </div>
    </div>
  </section>
);

// About Section
const AboutSection = () => (
  <section id="o-nama" className="py-10 md:py-20 bg-[#050505] relative overflow-hidden" data-testid="about-section">
    {/* Decorative background */}
    <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#8B2942]/5 to-transparent pointer-events-none" />
    <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl pointer-events-none" />
    <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 relative z-10">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
        <div className="relative">
          <div className="w-full max-w-md">
            <img src="https://customer-assets.emergentagent.com/job_de26a693-6312-4006-859a-46abd035f31f/artifacts/e8m4prmg_logo%20kabinet.png" alt="Kabinet Proslave Logo" className="w-full h-auto" />
          </div>
          <div className="mt-6 inline-block bg-[#0A0A0A] border border-[#D4AF37]/30 p-5 md:p-6">
            <p className="font-['Cormorant_Garamond'] text-3xl md:text-4xl text-[#D4AF37]">10+</p>
            <p className="text-xs tracking-[0.1em] uppercase text-[#A1A1AA]">Godina iskustva</p>
          </div>
        </div>
        <div>
          <p className="text-sm tracking-[0.3em] uppercase text-[#D4AF37] mb-4">O nama</p>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-6xl lg:text-7xl font-medium tracking-tight text-[#FAF8F5] mb-2 leading-tight">
            Vaš partner za
          </h2>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-6xl lg:text-7xl font-medium tracking-tight mb-8 leading-tight">
            <span className="text-gold-gradient">nezaboravne trenutke</span>
          </h2>
          <div className="space-y-4 text-[#A1A1AA] text-lg md:text-xl leading-relaxed">
            <p>Kabinet Proslave je osnovan sa jednim ciljem - da našim gostima pružimo vrhunski provod u najbolje opremljenom prostoru.</p>
            <p>Prostor je pogodan za proslave do 20, 50 ili 100 ljudi, za proslavu 18. rođendana, rođenje deteta, diplomskog, rođendana ili bilo koji drugi vid proslave!</p>
          </div>
          <div className="grid grid-cols-3 gap-2 md:gap-3 mt-8">
            <div className="text-center p-2 md:p-3 border border-[#8B2942]/30 bg-[#8B2942]/5">
              <p className="font-['Cormorant_Garamond'] text-xl md:text-3xl text-[#D4AF37]">500+</p>
              <p className="text-[10px] md:text-xs tracking-[0.1em] uppercase text-[#A1A1AA] mt-1">Proslava</p>
            </div>
            <div className="text-center p-2 md:p-3 border border-[#8B2942]/30 bg-[#8B2942]/5">
              <p className="font-['Cormorant_Garamond'] text-xl md:text-3xl text-[#D4AF37]">100%</p>
              <p className="text-[10px] md:text-xs tracking-[0.05em] uppercase text-[#A1A1AA] mt-1">Zadovoljno</p>
            </div>
            <div className="text-center p-2 md:p-3 border border-[#8B2942]/30 bg-[#8B2942]/5">
              <p className="font-['Cormorant_Garamond'] text-xl md:text-3xl text-[#D4AF37]">24/7</p>
              <p className="text-[10px] md:text-xs tracking-[0.1em] uppercase text-[#A1A1AA] mt-1">Podrška</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

// Venue Section
const VenueSection = ({ venueImages }) => (
  <section id="nas-prostor" className="py-12 md:py-20 bg-gradient-to-b from-[#0A0A0A] via-[#0D0A0B] to-[#0A0A0A]" data-testid="venue-section">
    <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
      <div className="text-center mb-8">
        <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-3">Pogledajte</p>
        <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-medium tracking-tight text-[#FAF8F5]">
          Naš <span className="text-gold-gradient">prostor</span>
        </h2>
        <div className="luxury-divider mx-auto mt-6" />
      </div>
      <ImageSlider images={venueImages} title="Prostor" />
    </div>
  </section>
);

// Features Section
const FeaturesSection = () => (
  <section className="py-12 md:py-20 bg-gradient-to-br from-[#0A0A0A] via-[#0F0A0C] to-[#0A0A0A] relative overflow-hidden" data-testid="features-section">
    {/* Decorative elements */}
    <div className="absolute top-0 left-0 w-72 h-72 bg-[#8B2942]/10 rounded-full blur-3xl pointer-events-none" />
    <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl pointer-events-none" />
    <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 relative z-10">
      <div className="text-center mb-10">
        <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-3">Zašto mi?</p>
        <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-medium tracking-tight text-[#FAF8F5]">
          Pogodnosti <span className="text-gold-gradient">našeg lokala</span>
        </h2>
        <div className="luxury-divider mx-auto mt-6" />
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {FEATURES.map((feature, idx) => (
          <div key={idx} className="group p-6 bg-[#050505] border border-white/5 hover:border-[#8B2942]/50 transition-all duration-500 text-center" data-testid={`feature-${idx}`}>
            <div className="w-12 h-12 rounded-full border border-[#D4AF37]/30 flex items-center justify-center mb-4 group-hover:bg-[#8B2942]/20 group-hover:border-[#8B2942]/50 transition-colors duration-500 mx-auto">
              <feature.icon className="w-5 h-5 text-[#D4AF37] group-hover:text-[#D4AF37]" />
            </div>
            <h3 className="font-['Cormorant_Garamond'] text-lg text-[#FAF8F5] mb-2">{feature.title}</h3>
            <p className="text-[#A1A1AA] text-sm leading-relaxed">{feature.description}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

// Contact Section
const ContactSection = () => (
  <section id="kontakt" className="py-16 md:py-24 bg-gradient-to-b from-[#050505] via-[#0A0808] to-[#050505] relative overflow-hidden" data-testid="contact-section">
    {/* Decorative background circles */}
    <div className="absolute top-10 left-10 w-64 h-64 bg-[#8B2942]/10 rounded-full blur-3xl pointer-events-none" />
    <div className="absolute bottom-10 right-10 w-80 h-80 bg-[#D4AF37]/5 rounded-full blur-3xl pointer-events-none" />
    <div className="max-w-5xl mx-auto px-4 md:px-8 lg:px-12 relative z-10">
      <div className="text-center mb-12">
        <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-3">Kontakt</p>
        <h2 className="font-['Cormorant_Garamond'] text-3xl md:text-5xl font-medium tracking-tight text-[#FAF8F5] mb-4">
          Rezervišite <span className="text-gold-gradient">vaš termin</span>
        </h2>
        <p className="text-[#A1A1AA] max-w-xl mx-auto">Javite nam se i organizujte proslavu iz snova</p>
      </div>
      
      {/* Contact Cards */}
      <div className="grid md:grid-cols-2 gap-6 mb-8">
        {/* Phone Card */}
        <a href="tel:069713814" className="group block p-8 bg-[#0A0A0A] border border-[#8B2942]/30 hover:border-[#D4AF37]/50 transition-all duration-500 rounded-lg text-center">
          <div className="w-16 h-16 rounded-full bg-[#8B2942]/20 border border-[#D4AF37]/30 flex items-center justify-center mx-auto mb-4 group-hover:bg-[#D4AF37]/20 transition-colors">
            <Phone className="w-7 h-7 text-[#D4AF37]" />
          </div>
          <h3 className="font-['Cormorant_Garamond'] text-xl text-[#FAF8F5] mb-2">Pozovite nas</h3>
          <p className="text-[#D4AF37] text-2xl font-semibold group-hover:text-[#F4E4BC] transition-colors">069 713 814</p>
        </a>
        
        {/* Address Card */}
        <a href="https://maps.google.com/?q=Uspenska+5,+Novi+Sad" target="_blank" rel="noopener noreferrer" className="group block p-8 bg-[#0A0A0A] border border-[#8B2942]/30 hover:border-[#D4AF37]/50 transition-all duration-500 rounded-lg text-center">
          <div className="w-16 h-16 rounded-full bg-[#8B2942]/20 border border-[#D4AF37]/30 flex items-center justify-center mx-auto mb-4 group-hover:bg-[#D4AF37]/20 transition-colors">
            <MapPin className="w-7 h-7 text-[#D4AF37]" />
          </div>
          <h3 className="font-['Cormorant_Garamond'] text-xl text-[#FAF8F5] mb-2">Posetite nas</h3>
          <p className="text-[#A1A1AA] text-lg group-hover:text-[#F4E4BC] transition-colors">Uspenska 5, Novi Sad</p>
        </a>
      </div>
      
      {/* Google Maps */}
      <div className="mb-10 rounded-lg overflow-hidden border border-[#8B2942]/30">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2805.6372654892!2d19.8389!3d45.2551!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x475b10613c80f099%3A0x7c6d4b1c5a7e8d0f!2sUspenska%205%2C%20Novi%20Sad!5e0!3m2!1sen!2srs!4v1709149200000!5m2!1sen!2srs"
          width="100%"
          height="300"
          style={{ border: 0, filter: 'grayscale(100%) invert(92%) contrast(83%)' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Proslave Kabinet lokacija"
        />
      </div>
      
      {/* Social Links */}
      <div className="text-center mb-10">
        <p className="text-xs tracking-[0.2em] uppercase text-[#A1A1AA] mb-4">Pratite nas na mrežama</p>
        <div className="flex justify-center gap-4">
          <a href="https://www.facebook.com/proslavekabinetkafana/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-[#8B2942]/20 border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37]/20 hover:text-[#F4E4BC] transition-all">
            <Facebook className="w-5 h-5" />
          </a>
          <a href="https://www.instagram.com/proslave_kabinet/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 rounded-full bg-[#8B2942]/20 border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37]/20 hover:text-[#F4E4BC] transition-all">
            <Instagram className="w-5 h-5" />
          </a>
        </div>
      </div>
      
      {/* CTA Button */}
      <div className="text-center">
        <a href="tel:069713814" className="btn-luxury-primary text-lg px-12 py-4 inline-flex">
          <Phone className="w-5 h-5 mr-3" />
          Pozovite nas odmah!
        </a>
      </div>
    </div>
  </section>
);

// Footer
const Footer = () => (
  <footer className="py-8 bg-[#050505] border-t border-white/5" data-testid="footer">
    <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
        <img src="https://customer-assets.emergentagent.com/job_de26a693-6312-4006-859a-46abd035f31f/artifacts/e8m4prmg_logo%20kabinet.png" alt="Kabinet Logo" className="h-12" />
        <p className="text-[#525252] text-sm">© 2024 Proslave Kabinet. Sva prava zadržana.</p>
        <div className="flex gap-4">
          <a href="https://www.facebook.com/proslavekabinetkafana/" target="_blank" rel="noopener noreferrer" className="text-[#525252] hover:text-[#D4AF37] transition-colors">
            <Facebook className="w-5 h-5" />
          </a>
          <a href="https://www.instagram.com/proslave_kabinet/" target="_blank" rel="noopener noreferrer" className="text-[#525252] hover:text-[#D4AF37] transition-colors">
            <Instagram className="w-5 h-5" />
          </a>
        </div>
      </div>
    </div>
  </footer>
);

// Floating CTA
const FloatingCTA = () => (
  <a href="tel:069713814" className="fixed bottom-6 right-6 w-14 h-14 rounded-full bg-[#D4AF37] text-[#050505] flex items-center justify-center shadow-2xl hover:bg-[#F4E4BC] transition-colors z-40" data-testid="floating-cta">
    <Phone className="w-6 h-6" />
  </a>
);

// Gallery Page
const GalleryPage = () => {
  const { galleryImages } = useImages();
  const [selectedIndex, setSelectedIndex] = useState(null);

  const openLightbox = (idx) => setSelectedIndex(idx);
  const closeLightbox = () => setSelectedIndex(null);
  const nextImage = (e) => {
    e.stopPropagation();
    setSelectedIndex((prev) => (prev + 1) % galleryImages.length);
  };
  const prevImage = (e) => {
    e.stopPropagation();
    setSelectedIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
  };

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedIndex === null) return;
      if (e.key === 'ArrowRight') setSelectedIndex((prev) => (prev + 1) % galleryImages.length);
      if (e.key === 'ArrowLeft') setSelectedIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
      if (e.key === 'Escape') closeLightbox();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedIndex, galleryImages.length]);

  return (
    <div className="min-h-screen bg-[#050505]">
      <Navigation isGalleryPage={true} />
      
      <div className="pt-32 pb-12 px-4">
        <div className="max-w-7xl mx-auto">
          <Link to="/" className="inline-flex items-center text-[#D4AF37] hover:text-[#F4E4BC] transition-colors mb-8">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Nazad na početnu
          </Link>
          <h1 className="font-['Cormorant_Garamond'] text-4xl md:text-6xl font-medium text-[#FAF8F5] mb-4">
            Galerija <span className="text-gold-gradient">proslava</span>
          </h1>
          <p className="text-[#A1A1AA] text-lg">Pogledajte trenutke sa naših proslava</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 pb-20">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {galleryImages.map((img, idx) => (
            <div key={idx} className="aspect-square overflow-hidden cursor-pointer group" onClick={() => openLightbox(idx)}>
              <img src={img} alt={`Proslava ${idx + 1}`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
            </div>
          ))}
        </div>
      </div>

      {selectedIndex !== null && (
        <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center" onClick={closeLightbox} data-testid="lightbox">
          {/* Close button */}
          <button className="absolute top-6 right-6 text-white hover:text-[#D4AF37] transition-colors z-10" onClick={closeLightbox} data-testid="lightbox-close">
            <X className="w-8 h-8" />
          </button>
          
          {/* Previous arrow */}
          <button 
            onClick={prevImage} 
            className="absolute left-4 md:left-8 top-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 rounded-full bg-black/50 border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37]/20 transition-colors z-10"
            data-testid="lightbox-prev"
          >
            <ChevronLeft className="w-6 h-6 md:w-8 md:h-8" />
          </button>
          
          {/* Image */}
          <img 
            src={galleryImages[selectedIndex]} 
            alt={`Gallery ${selectedIndex + 1}`} 
            className="max-w-[85%] md:max-w-[75%] max-h-[85vh] object-contain" 
            onClick={(e) => e.stopPropagation()} 
          />
          
          {/* Next arrow */}
          <button 
            onClick={nextImage} 
            className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 w-12 h-12 md:w-14 md:h-14 rounded-full bg-black/50 border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37]/20 transition-colors z-10"
            data-testid="lightbox-next"
          >
            <ChevronRightIcon className="w-6 h-6 md:w-8 md:h-8" />
          </button>
          
          {/* Image counter */}
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/70 text-sm">
            {selectedIndex + 1} / {galleryImages.length}
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

// Main Page
const MainPage = () => {
  const [activeSection, setActiveSection] = useState("hero");
  const { galleryImages, venueImages, heroImages } = useImages();

  useEffect(() => {
    const handleScroll = () => {
      const sections = ["hero", "proslave", "galerija-preview", "o-nama", "nas-prostor", "kontakt"];
      const scrollPos = window.scrollY + 200;
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const top = element.offsetTop;
          const height = element.offsetHeight;
          if (scrollPos >= top && scrollPos < top + height) {
            setActiveSection(section);
            break;
          }
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="App">
      <Navigation activeSection={activeSection} />
      <main>
        <HeroSection heroImages={heroImages} />
        <CelebrationsSection />
        <GalleryPreviewSection galleryImages={galleryImages} />
        <AboutSection />
        <VenueSection venueImages={venueImages} />
        <FeaturesSection />
        <ContactSection />
      </main>
      <Footer />
      <FloatingCTA />
    </div>
  );
};

// App
function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors toastOptions={{ style: { background: "#0A0A0A", border: "1px solid rgba(212, 175, 55, 0.3)", color: "#FAF8F5" } }} />
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/galerija" element={<GalleryPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
